import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'

import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import FileDownloadAndPrint from './FileDownloadAndPrint'
import { STEP } from '../../components/Project/projectStepManager'
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`

function Pdfcontain({ file, mini, num, list, single, type, agree, onClick, nums, data, top, project }) {
    const [numPages, setNumPages] = useState(null)
    const [pageNumber, setPageNumber] = useState(1)

    const onDocumentLoaded = ({ numPages }) => setNumPages(numPages)

    useEffect(() => {
        setPageNumber(1)
    }, [file, num])

    const pagecouter = (types) => {
        if (pageNumber === 1 && numPages === pageNumber) {
            if (types) {
                Swal.fire('마지막페이지 입니다', '확인 버튼을 눌러 주세요', 'error')
            } else {
                Swal.fire('처음페이지 입니다', '확인 버튼을 눌러 주세요', 'error')
            }
        } else if (pageNumber === 1) {
            if (types) {
                setPageNumber(pageNumber + 1)
            } else {
                Swal.fire('처음페이지 입니다', '확인 버튼을 눌러 주세요', 'error')
            }
        } else if (numPages === pageNumber) {
            if (!types) {
                setPageNumber(pageNumber - 1)
            } else {
                Swal.fire('마지막페이지 입니다', '확인 버튼을 눌러 주세요', 'error')
            }
        } else if (types) {
            setPageNumber(pageNumber + 1)
        } else {
            setPageNumber(pageNumber - 1)
        }
    }

    const canShowApproveButton = agree && (nums === 1 || nums === 5 || nums === 6 || nums === 7)

    const hasApproveFile =
        (nums === 1 && data && data.estimate) ||
        (nums === 5 && data && data.develop1) ||
        (nums === 6 && data && data.develop2) ||
        (nums === 7 && data && data.develop3)

    const isAlreadyApproved =
        (nums === 1 && data && data.b3f) ||
        (nums === 5 && data && data.r1f) ||
        (nums === 6 && data && data.r2f) ||
        (nums === 7 && data && data.r3f)

    const approveAlertMessage =
        nums === 1
            ? '견적서 파일 업로드 후 승인할 수 있습니다.'
            : nums === 5
            ? '1단계 개발 보고서 파일 업로드 후 승인할 수 있습니다.'
            : nums === 6
            ? '2단계 개발 보고서 파일 업로드 후 승인할 수 있습니다.'
            : '3단계 개발 보고서 파일 업로드 후 승인할 수 있습니다.'
    // const pdfTitle =
    //     type === 'estimate'
    //         ? '개발 견적서'
    //         : project && project.adminstatus === STEP.DONE
    //         ? '완료 보고서'
    //         : nums === 5
    //         ? '1단계 개발 보고서'
    //         : nums === 6
    //         ? '2단계 개발 보고서'
    //         : nums === 7
    //         ? '3단계 개발 보고서'
    //         : '개발 사양서'
    const pdfTitle =
        type === 'estimate'
            ? '견적서'
            : nums === 5
            ? '1단계 개발 보고서'
            : nums === 6
            ? '2단계 개발 보고서'
            : nums === 7
            ? '3단계 개발 보고서'
            : project && project.adminstatus === STEP.DONE
            ? '완료 보고서'
            : '사양서'
    return (
        <div>
            <div className="pdfTop flex j">
                <div className="flex l">
                    <div className="est-dev-contract mr10">{pdfTitle}</div>
                </div>

                <div className="flex r mr10">
                    <button className="next_btn_hover p10 mt10 ml10" onClick={() => pagecouter(false)}>
                        이전
                    </button>

                    <span className="mr10 flex a">
                        <span className="pdf_border-box p10 mt10 ml10">
                            {pageNumber} / {numPages}
                        </span>
                    </span>

                    <button className="next_btn_hover p10 mt10 mr10" onClick={() => pagecouter(true)}>
                        다음
                    </button>

                    <FileDownloadAndPrint list={list} single={single} type={type} />

                    {canShowApproveButton ? (
                        <button
                            onClick={() => {
                                if (!hasApproveFile) {
                                    Swal.fire(approveAlertMessage, '확인 버튼을 눌러 주세요', 'warning')
                                    return
                                }

                                if (isAlreadyApproved) {
                                    Swal.fire('이미 승인 완료되었습니다.', '확인 버튼을 눌러 주세요', 'info')
                                    return
                                }

                                onClick(nums)
                            }}
                            className="next_btn_hover p10 mt10 ml20"
                            disabled={!hasApproveFile || isAlreadyApproved}
                            style={{
                                opacity: !hasApproveFile || isAlreadyApproved ? 0.45 : 1,
                                cursor: !hasApproveFile || isAlreadyApproved ? 'not-allowed' : 'pointer',
                                backgroundColor: !hasApproveFile || isAlreadyApproved ? '#c8c8c8' : '',
                                color: !hasApproveFile || isAlreadyApproved ? '#666' : '',
                                border: !hasApproveFile || isAlreadyApproved ? '1px solid #c8c8c8' : '',
                                boxShadow: !hasApproveFile || isAlreadyApproved ? 'none' : '',
                                filter: !hasApproveFile || isAlreadyApproved ? 'grayscale(100%)' : '',
                            }}
                        >
                            {isAlreadyApproved ? '승인완료' : '승인'}
                        </button>
                    ) : (
                        ''
                    )}
                </div>
            </div>

            <div className="flex center">
                <div className="quote-container mt20">
                    <Document
                        className={mini ? 'pdfcontain mini' : 'pdfcontain'}
                        file={file}
                        onLoadSuccess={onDocumentLoaded}
                        renderMode="svg"
                    >
                        <Page scale={3} annotationLayer={false} renderTextLayer={false} pageNumber={pageNumber} />
                    </Document>
                </div>
            </div>
        </div>
    )
}

export default Pdfcontain
